export const pageView = (url, title) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.gtag(
    'config',
    process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID,
    {
      page_location: url,
      page_title: title,
    }
  );
};
